import config from "@/utils/Config";
import {get, post } from "@/utils/request";

export function pubLife(params = { title: title, content: content }) {
    return post(config.BASE_URL, config.pubLifeUrl, params)
}

export function delLife(params = { id: id }) {
    return post(config.BASE_URL, config.delLifeUrl, params)
}

export function getLifeList(params = { pageNo: pageNo, pageSize: pageSize }) {
    return post(config.BASE_URL, config.getLifeList, params)
}

export function getLifeDetail(params = { pageNo: pageNo, pageSize: pageSize }) {
    return post(config.BASE_URL, config.getLifeDetail, params)
}

export function getLifeAdminList(params = {}) {
    return post(config.BASE_URL, config.getLifeAdminListUrl, params)
}

export function getArchivesList(params = {}) {
    return get(config.BASE_URL, config.getArchives, params)
}

export function getLifeListByMonthInfo(params = { date: date }) {
    return get(config.BASE_URL, config.getLifeListByMonth, params)
}

export function getLifeTypeListByCount(params = {}) {
    return get(config.BASE_URL, config.getLifeTypeListByCountUrl, params)
}

export function getLifeTypeList(params = {}) {
    return get(config.BASE_URL, config.getLifeTypeListUrl, params)
}

export function saveLifeType(params = {}) {
    return post(config.BASE_URL, config.saveLifeTypeUrl, params)
}

export function getLifeTypeAdminList(params = {}) {
    return post(config.BASE_URL, config.getLifeTypeListAdminUrl, params)
}

export function delLifeType(params = { id: id }) {
    return post(config.BASE_URL, config.delLifeTypeUrl, params)
}